import React from 'react'
import { Link } from 'react-router-dom'
const Footer = () => {

 const d = new Date()
  const year = d.getFullYear()

    return (
        <footer style={{ width: "100%" }}>
            <div className='bt-1px py-3' style={{ backgroundColor: "#021b38" }}  >
                <div className='container' >
                    <div className='row' >
                        <div className='col-md-12 text-center mt-3' >
                            <p style={{ color: "#FFF", fontSize: 18 }} >Copyright ©Get Better Transportation {year}.<br className='d-block d-md-none' /> Designed by <span  ><Link style={{ color: "#97c11e", textDecoration: "none", fontWeight: 600 }} to="https://bitcomvalley.com" target='_blank' >Bitcom Valley</Link></span></p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer